import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);


const routes = [


  {
    path: "/error-nologin",
    component: () => import("@/views/error/error-nologin"),
  },






{
        path: "/",
    
        component: () => import("@/views/home"),
},


  {
    path: "/share",
    component: () => import("@/views/share/Share"),
  },



];

const router = new VueRouter({
  routes,
})
export default router;